import React, { useEffect } from 'react';
import { brandConfigPromise } from '../brand';

interface BrandThemeProviderProps {
  children: React.ReactNode;
}

export const BrandThemeProvider: React.FC<BrandThemeProviderProps> = ({ children }) => {
  useEffect(() => {
    brandConfigPromise.then(config => {
      const root = document.documentElement;

      const applyPalette = (palette: Record<string, string>, prefix: 'primary' | 'secondary') => {
        Object.entries(palette).forEach(([key, value]) => {
          if (key === 'DEFAULT') {
            root.style.setProperty(`--color-${prefix}`, value);
          } else {
            root.style.setProperty(`--color-${prefix}-${key}`, value);
          }
        });

        if (!palette.DEFAULT && palette['500']) {
          root.style.setProperty(`--color-${prefix}`, palette['500']);
        }
      };

      applyPalette(config.colors.primary, 'primary');
      applyPalette(config.colors.secondary, 'secondary');

      if (config.name) {
        document.title = config.name;
      }
    });
  }, []);

  return <>{children}</>;
};
